// console.log("sample js");
// import $ from "jquery";
document.addEventListener('click', function(e) {
    const button = e.target.closest('.cu-faculty-intro__more');

    if (!button) {
        return;
    }

    const targetId = button.getAttribute('aria-controls');
    const content = document.getElementById(targetId);

    if (!content) {
        return;
    }

    const expanded = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    content.hidden = expanded;

    const label = button.querySelector('.cu-faculty-intro__more-label');

    if (label) {
        label.textContent = expanded ? 'More' : 'Less';
    }
});